import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {EMPTY, Observable} from "rxjs";
import {AdministratorsService, Features, OrganiserUsersService} from "@services";
import {FindUsersDetailsRequest, UserDetail, UsersDetailFilter} from "@model";
import {USER_LIST} from "../app-routing.module";
import {inject} from "@angular/core";

export const UserListResolver: ResolveFn<Observable<UserDetail[]> | UserDetail[]> | any =
  (route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    router: Router,
    organiserUserService: OrganiserUsersService = inject(OrganiserUsersService),
    adminService: AdministratorsService = inject(AdministratorsService)): Observable<UserDetail[]> | UserDetail[] | any => {
    const role = route.queryParams['role'] ? +route.queryParams['role'] : undefined;
    const text = route.queryParams['text'] ? route.queryParams['text'] : undefined;
    const feature : Features = route.data['feature'];

    switch (feature) {
      case Features.Users:
        if ((role && UsersDetailFilter.ROLES.includes(role)) || !role) {
          return adminService.findUsers(FindUsersDetailsRequest.createUsersDetailsRequest(1, { role: role, text: text }), true);
        }
        else {
          router.navigate([USER_LIST])
          return EMPTY
        }
      case Features.OrganisersEdit:
        return organiserUserService.findUsers(+route.queryParams['organiserId']);
      case Features.OrganiserProfile:
        return organiserUserService.findUsers();
      default:
        router.navigate([USER_LIST]);
        return EMPTY;
    }
  }
